import React from "react";
import Navbar from "./components/navbar";
import CreateToptradingComponent from "./create/create.component";
import CreateToptradingProvider from "./create/provider/createToptrading.provider";
import CreateUsedToptradingProvider from "./create/used/provider/createUsedToptrading.provider";
import CreateNewsToptradingProvider from "./create/news/provider/createNewsToptrading.provider";

const ToptradingPage = () => {
  return (
    <CreateToptradingProvider>
      <CreateNewsToptradingProvider>
        <CreateUsedToptradingProvider>
          <div className="h-screen overflow-auto bg-gradient-to-b from-white to-[#192B53]">
            <Navbar />
            <section className="flex h-full w-full items-center justify-center p-0">
              <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                <CreateToptradingComponent />
              </div>
            </section>
          </div>
        </CreateUsedToptradingProvider>
      </CreateNewsToptradingProvider>
    </CreateToptradingProvider>
  );
};

export default ToptradingPage;
